import { withDefaultProps } from '@aspectus/vue-utils'
import Select from './Select'
import ControlDescriptor from './ControlDescriptor'


const dt = tag => withDefaultProps({ tag })(ControlDescriptor)

export const DSelect = dt(Select)
